import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService, CompanyService, Toaster } from '@app/services';
import { LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { filter, first, map, switchMap } from 'rxjs/operators';
import * as UserActions from '@app/store/actions/user.actions';
import { Store } from '@ngrx/store';
import { User } from '@app/models';
import * as _ from 'lodash';
import { environment } from '@env/environment';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../layout/auth.style.scss'],
})
export class LoginComponent implements OnInit {
  env = environment;
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });
  user: any = {};
  submitted: boolean = false;
  returnUrl: string = '';
  password_changed: boolean;
  userToken: string;

  @LocalStorage() token: string;
  @LocalStorage() organizationId: string;
  @LocalStorage() companyType: string;
  @LocalStorage() companyLogo: string;
  @LocalStorage() siteName: string;
  @LocalStorage() role: string;
  @LocalStorage() refresh: string;

  constructor(
    private $account: AccountService,
    private $company: CompanyService,
    private $toaster: Toaster,
    protected router: Router,
    protected store: Store<{ user: User }>,
    protected route: ActivatedRoute,
    protected localStorageService: LocalStorageService,
  ) {
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => (this.returnUrl = params['return'] || '/dashboard'));
  }

  getToken() {
    if (this.email.value !== null && this.email.value !== '') {
      this.$account.checkPasswordSetting(this.email.value).subscribe(res => {
        this.userToken = res.token;
        this.password_changed = res.password_changed;
      });
    }
  }

  login() {
    this.submitted = true;

    this.user.email = this.email.value;
    this.user.username = this.email.value;
    this.user.password = this.password.value;

    this.localStorageService.clear();
    this.$account
      .login(this.user)
      .pipe(
        switchMap(res => {
          const refresh: string = String(res.headers.get('Refresh'));
          const token: string = String(res.headers.getAll('Authorization'));
          this.token = token;
          this.refresh = refresh;
          this.store.dispatch(new UserActions.Fetch());
          return this.store.select('user')
            .pipe(filter(value => !_.isEmpty(value))).pipe(first());
          // return this.$account.getProfile();
        }),
        switchMap(res => {
          this.role = res.role;
          this.organizationId = res.organization_id;
          return this.$company.getById(this.organizationId)
            .pipe(map((company) => {
              return { user: res, company };
            }));
        }),
      )
      .subscribe(
        ({ user, company }) => {
          this.companyType = company.login_as;
          this.companyLogo = company.logo;
          this.siteName = company.site_name;
          if (this.companyType === 'supplier' && !!user.first_po_id) {
            return this.router.navigate(['/suppliers', 'work-in-progress', user.first_po_id], {});
          }

          this.router.navigateByUrl(this.returnUrl);
        },
        error => {
          if (error.status === 400) {
            this.$toaster.show('error', 'Login Error', 'Wrong credentials provided');
          } else if (error.status === 403) {
            this.$toaster.show('error', 'Login Error', 'Not authorized to log in');
          } else {
            this.$toaster.show('error', 'Login Error', 'Something went wrong, please try again later');
          }
          this.submitted = false;
        },
      );
  }
}
